import { createSlice } from "@reduxjs/toolkit";

const initialState = {
 useId : '',
 userName :'',
activityTitle:'',
userProfileImage:'',
vendorIsApproved :false

};

const upSwapSlice = createSlice({
  name: "upSwap",
  initialState,
  reducers: {
    setUserId: (state, action) => {
      state.useId = action.payload;
    },
    setUserName :(state , action)=>{
        state.userName = action.payload
    },
     setActivityTitle :(state , action)=>{
        state.activityTitle = action.payload
    },
     setUserProfileImage :(state , action)=>{
        state.userProfileImage = action.payload
    },
     setVendorIsApproved :(state , action)=>{
        state.vendorIsApproved = action.payload
    }

  },
});

export const {setUserId , setUserName , setUserProfileImage , setActivityTitle , setVendorIsApproved } = upSwapSlice.actions;
export default upSwapSlice.reducer;